import apiClient from "../../../api/apiClient";
import { ApiDateFormatRequest } from "../../../models/Request/apiDateFormatRequest";
import { DepositHistoryListResponse } from "../models/response/depositHistoryListResponse";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { LastDepositResponse } from "../models/response/lastDepositResponse";
import { ValidateTransactionUpdateResponse } from "../models/response/validateTransactionUpdateResponse";
import { DepositTransactionUpdateRequest } from "../models/request/depositTransactionUpdateRequest";
import { UploadDocumentRequest } from "../models/request/uploadDocumentRequest";
import { BalanceAdjustmentListResponse } from "../models/response/balanceAdjustmentListResponse";
import { UserHistoryListRequest } from "../../../models/Request/userHistoryListRequest";
import { Withdrawhistorylistresponse } from "../models/response/withdrawHistoryListResponse";
import { LastWithdrawalResponse } from "../models/response/lastWithdrawalResponse";
import { Withdrawcancelrequest } from "../../../models/Request/withdrawCancelRequest";
import { WithdrawTransactionUpdateRequest } from "../models/request/withdrawTransactionUpdateRequest";
import { CasinoHistoryListResponse } from "../models/response/casinoHistoryListResponse";
import { ExchangeHistoryListResponse } from "../models/response/exchangeHistoryListResponse";
import { SportsHistoryListResponse } from "../models/response/sportsHistoryListResponse";
import { BetByDetailsRequest } from "../models/request/betByDetailsRequest";
import { SportsHistorySummaryResponseDetails } from "../models/response/sportsHistorySummaryResponse";

export const transactionsApi = {
    getDepositHistory: async (request: ApiDateFormatRequest): Promise<UnifiedResponse<DepositHistoryListResponse>> => {
        const response = await apiClient.post<UnifiedResponse<DepositHistoryListResponse>>(
            "/users/deposit/retrieve/details",
            request
        );
        return response.data;
    },

    revertUserDepositById: async (depositId: string) => {
        const response = await apiClient.post<UnifiedResponse<any>>(
            "/payment/deposit/revert",
            { id: depositId }
        );
        return response.data;
    },

    getUserLastDeposit: async (): Promise<UnifiedResponse<LastDepositResponse>> => {
        const response = await apiClient.get<UnifiedResponse<LastDepositResponse>>("/payment/deposit/check_payment", {});
        return response.data;
    },

    validateUsersDepositTransactionUpdateById: async (depositId: string): Promise<ValidateTransactionUpdateResponse | null> => {
        const response = await apiClient.post<UnifiedResponse<ValidateTransactionUpdateResponse>>("/users/deposit/transaction/update/validate", depositId);
        return response.data.data;
    },

    addUsersDepositTransactionUpdateRequest: async (request: DepositTransactionUpdateRequest): Promise<any> => {
        const response = await apiClient.post<UnifiedResponse<any>>("/users/deposit/transaction/update/insert", request);
        return response.data;
    },

    uploadTransactionUpdateDocument: async (request: UploadDocumentRequest): Promise<UnifiedResponse<any>> => {
        const response = await apiClient.post<UnifiedResponse<any>>("/users/transaction/update/document/upload", request, {
            headers: {
                "Content-Type": "multipart/form-data",
                "X-Client-Domain": "User",
            },
        });
        return response.data;
    },

    getAdjustmentHistory: async (request: ApiDateFormatRequest): Promise<UnifiedResponse<BalanceAdjustmentListResponse>> => {
        const response = await apiClient.post<UnifiedResponse<BalanceAdjustmentListResponse>>(`/users/balance/history/details`, request);
        return response.data;
    },
    getWithdrawHistory: async (request: UserHistoryListRequest): Promise<UnifiedResponse<Withdrawhistorylistresponse>> => {
        const response = await apiClient.post<UnifiedResponse<Withdrawhistorylistresponse>>(
            "/users/withdraw/retrieve/details",
            request
        );
        return response.data;
    },

    getUserLastWithdrawal: async (): Promise<UnifiedResponse<LastWithdrawalResponse>> => {
        const response = await apiClient.post<UnifiedResponse<LastWithdrawalResponse>>("/payment/withdraw/retrieve_last_request", {});
        return response.data;
    },

    validateUsersWithdrawTransactionUpdateById: async (id: string): Promise<ValidateTransactionUpdateResponse | null> => {
        const response = await apiClient.post<UnifiedResponse<any>>("/users/withdraw/transaction/update/validate", id);
        const result = response.data.data;
        const data: ValidateTransactionUpdateResponse = {
            isUpdateVisible: result?.isupdatevisible ?? false,
            isDisabled: result?.isdisabled ?? false,
        }
        return data;
    },

    UserWithdrawRequestUpdateStatus: async (request: Withdrawcancelrequest): Promise<UnifiedResponse<any>> => {
        const response = await apiClient.post<UnifiedResponse<any>>("/payment/withdraw/cancel", request);
        return response.data;
    },

    addUsersWithdrawTransactionUpdateRequest: async (request: WithdrawTransactionUpdateRequest): Promise<any> => {
        const response = await apiClient.post<UnifiedResponse<any>>("/users/withdraw/transaction/update/insert", request);
        return response.data;
    },

    getUserCasinoTransectionHistory: async (request: ApiDateFormatRequest): Promise<UnifiedResponse<CasinoHistoryListResponse>> => {
        const response = await apiClient.post<UnifiedResponse<CasinoHistoryListResponse>>("/users/casino/history/details", request);
        return response.data;
    },

    getUserExchangeTransectionHistory: async (request: UserHistoryListRequest): Promise<UnifiedResponse<ExchangeHistoryListResponse>> => {
        const response = await apiClient.post<UnifiedResponse<ExchangeHistoryListResponse>>("/users/exchange/history/details", request);
        return response.data;
    },

    getSportsHistory: async (request: UserHistoryListRequest): Promise<UnifiedResponse<SportsHistoryListResponse>> => {
        const response = await apiClient.post<UnifiedResponse<SportsHistoryListResponse>>(
            "/users/sports/history/details",
            request
        );
        return response.data;
    },

    getSportsBetHistoryDetails: async (request: BetByDetailsRequest): Promise<UnifiedResponse<SportsHistorySummaryResponseDetails>> => {
        const response = await apiClient.post<UnifiedResponse<SportsHistorySummaryResponseDetails>>(
            "/users/sports/singlebet/details",
            request
        );
        return response.data;
    },
};